import React from 'react'

const ContactCard = ({ icon, title, linkTitle, link, iconClass }) => {
  return (
    <div className='contact-item-card'>
      <div className={`icon ${iconClass}`}>
        {icon}
      </div>
      <div className="content">
        <span className="title">{title}</span>
        <a href={link}>{linkTitle}</a>
      </div>
    </div>
  )
}

export default ContactCard